<template>
    <div class="my-1">
        <b-card>
            <div class="row">
                <div class="col-7">
                    <!-- <p class="card-text">
                    <b>{{ hotel.hotel }}</b><br>
                    <small>{{ hotel.pobla }}</small>
                    </p> -->
                    <div class="form-group">
                        <label class="text-small">Destinos / Hoteles</label>
                        <b-form-select v-model="hot"
                            :options="hoteles" value-field="hot" text-field="hotel"
                            @change="hotel_precios"
                            class="mb-1"
                        ></b-form-select>
                        <p class="ml-2"><small>{{ pob }}</small></p>
                    </div>
                </div>
                <div class="col-5">
                    <!-- <b-icon variant="success" icon="cart3"></b-icon> -->
                    <div class="form-group">
                        <label class="text-small">Salidas / Transporte</label>
                        <b-form-select v-model="sal"
                            :options="salidas"
                            class="mb-1"
                        ></b-form-select>
                    </div>
                </div>
            </div>
            <b-table striped hover sticky-header="440px" head-variant="light"
                :items="turnosFiltrados" :fields="turnos.fields"
                class="table-responsive-md bg-white" responsive="sm">

                <template slot="cell(sal)" slot-scope="{item: { sal }}">
                    <small>{{ sal }}</small>
                </template>

                <template #cell(action)="data">
                    <b-btn size="lg" variant="light" class="p-0" v-if="data.item.lib<=0">
                        <b-icon variant="danger" icon="x-square"></b-icon>
                    </b-btn>
                    <b-btn size="md" variant="success" class="p-1" v-else @click="selecciona(data)">
                        <b-icon icon="cart3"></b-icon>
                        <b-badge variant="success">{{data.item.lib}}</b-badge>
                    </b-btn>
                </template>

            </b-table>
            <!-- <p><small>Periodos </small> <b> {{turnos.items.length}} </b></p> -->
        </b-card>
        <div class="row mx-1 pl-4 mt-1 bg- text-faded">
            <div class="col-6">Periodos <b>{{turnosFiltrados.length}}</b></div>
            <div class="col-6 pr-5 mt-1">
                <b-icon variant="success" icon="cart3"></b-icon> Reservar
                <b-icon variant="danger" icon="x-square" class="ml-4"></b-icon> Sin disponibilidad
            </div>
        </div>
    </div>
</template>

<script>

export default {
    name: 'hotelDispo',

    data() {
        return {
            hotel: {},
            hot: '',
            pob: '',
            sal: '',
            salidas: [],
        }
    },

    mounted() {
        console.log('*mounted',this.hot,this.hotel,this.hoteles,this.turnos);
        //if (this.hot>'') return;
        this.hot=(this.hotel.hot>0 ? this.hotel.hot : this.hoteles[0].hot);
        this.hotel_precios(this.hot);
    },

    computed: {

        hoteles() {
            return this.$store.state.hoteles.destinos;
        },
        salidas0() {
            return this.$store.state.hoteles.salidas;
        },

        // hotel() {
        //     return this.$store.state.hoteles.hotel;
        // },

        turnos() {
            return this.$store.state.hoteles.turnos;
        },

        turnosFiltrados() {
            // var H=this.$util.object_array(this.turnos.items);
            var H=this.turnos.items;
            if (this.sal>'') {
                H = H.filter(item => item.sal.indexOf(this.sal) != -1);
            }
            //return this.$util.array_object(H);
            return H;
        },

        // salidas() { console.log('salidas',this.sal,this.turnos);
        //     // let result=this.$util.object_array(this.turnos.items);
        //     let result=this.turnos.items;

        //     var A=[{text:"Selecciona Transporte", value:'', disabled:false}];
        //     result.forEach(value => {
        //         let txt=(value.sal=='*SIN TRANSPORTE'?'* Sin Transporte':"BUS - "+value.sal);

        //         let names = A.map(e => e.value);
        //         //console.log(names.includes(value.sal)); // returns true
        //         if (!names.includes(value.sal))
        //             A.push({text:txt, value:value.sal, disabled:false});
        //     });

        //     return A;
        // },

    },
    methods: {

        async hotel_precios(item='') {
            if (item=='') item=this.hot;

            //buscamos en hoteles
            let index = this.hoteles.map((o) => o.hot).indexOf(item);
            this.hotel =this.hoteles[index];
            console.log('*hotel_dispo.hotel_precios',this.hoteles,item,index,this.hotel);

            await this.$store.dispatch('hotel_precios', this.hotel);

            this.salidas=this.hotel_salidas();

            this.hot=item;
            this.pob=this.hotel.pobla + " -  " + this.hotel.zon;
            this.sal=this.salidas[0].value;
        },

        hotel_salidas() {
            // let result=this.$util.object_array(this.turnos.items);
            let result=this.turnos.items;

            var A=[{text:"Selecciona Transporte", value:'', disabled:false}];
            result.forEach(value => {
                let txt=(value.sal=='*SIN TRANSPORTE'?'* Sin Transporte':"BUS - "+value.sal);

                let names = A.map(e => e.value);
                //console.log(names.includes(value.sal)); // returns true
                if (!names.includes(value.sal))
                    A.push({text:txt, value:value.sal, disabled:false});
            });

            return A;
        },

        selecciona(item) {
            this.$store.state.hoteles.hotel=this.hotel;
            this.$store.state.hoteles.turno=item.item;
            // abrimos reservar sino ...
            if (this.$route.name!='reservar')
                this.$router.push('/reservar');
            console.log("*selecciona",item.item.id,this.$store.state.hoteles.turno);
            this.close();
        },

        close() {
            this.$bvModal.hide('modal_hotelDispo');
        }
    }
}
</script>
